module.exports = __webpack_public_path__ + "img/4-2.085e9306.svg";